import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DevAuthService } from 'src/app/core/auth/dev-auth.service';
import { myPreferencesUrl } from 'src/app/core/utils/my-links.util';
import { IonicModule } from '@ionic/angular';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-shell-header',
    templateUrl: './shell-header.component.html',
    styleUrls: ['./shell-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        RouterLink,
        RouterLinkActive,
        TranslatePipe,
    ],
})
export class ShellHeaderComponent {
  readonly title = input('');

  /** Below ~900px the 4 nav links move out of the toolbar into this toggled panel —
   *  see shell-header.component.scss for why this is a plain signal + CSS transition
   *  rather than ion-menu (the app shell was deliberately restructured to keep the
   *  header outside ion-router-outlet with no ion-content for a menu to attach to). */
  navOpen = false;

  /** Language and appearance are chosen in My-SPA and apply in every app. */
  readonly myPreferencesUrl = myPreferencesUrl();

  constructor(public auth: DevAuthService) { }

  toggleNav(): void {
    this.navOpen = !this.navOpen;
  }

  closeNav(): void {
    this.navOpen = false;
  }
}
